import { FilterBy } from '../consts'

/**
 * FactoryMethod of Filter
 */
export const By = (condition = {}) => {
  if (condition.keyword) {
    // if keyword is not empty
    return ByKeyword(condition.keyword)
  } else {
    return None
  }
}

/**
 */
export const None = (entry) => true

/**
 *
 */
export const ByKeyword = (keyword) => (entry) => {
  const searchText = [
    entry.project_name,
    entry.prefectures,
    entry.city,
    entry.street,
  ].join(',')

  return searchText.indexOf(keyword) >= 0
}
